<template>
  <v-data-table :headers="headers" :items="exams" sort-by="calories" class="elevation-1 main-table">
    <template v-slot:top>
      <div
        class="d-flex align-center flex-wrap pa-4"
        :class="{
          'flex-column': !$vuetify.breakpoint.mdAndUp,
        }"
      >
        <div>Exames</div>

        <v-dialog v-model="dialogExamUpdate" max-width="700px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              text
              class="py-4"
              :class="[attrs, { 'ml-auto mr-3': $vuetify.breakpoint.mdAndUp }]"
              v-on="on"
              small
              >{{ $vuetify.breakpoint.mdAndUp ? 'ADICIONAR ATUALIZAÇÃO DE EXAMES' : 'ATUALIZAR EXAMES' }}</v-btn
            >
          </template>
          <v-card class="pb-2">
            <v-card-title> Adicionar atualização de exames </v-card-title>
            <v-card-text>
              <v-row class="ml-1">
                <v-col cols="4" class="pb-0">
                  <text-field
                    required
                    :mask="['##/##/####']"
                    label="Data dos Exames"
                    :rules="[$validation.validDate()]"
                    v-model="newExamsUpdate.date"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="text-left">Exame</th>
                        <th class="text-left">Resultado</th>
                        <th class="text-left">Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(exam, index) in exams" :key="index">
                        <td>{{ exam.examName }}</td>
                        <td class="d-flex justify-center">
                          <text-field
                            placeholder="Resultado"
                            v-model="newExamsUpdate.examsObject[exam.examId].value"
                          ></text-field>
                        </td>
                        <td>{{ newExamsUpdate.date }}</td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
              <v-btn color="blue darken-1" text @click="saveExamsUpdate"> Adicionar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogNewExam" max-width="700px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark :class="attrs" v-on="on">Novo Exame</v-btn>
          </template>
          <v-card>
            <v-card-title> Novos Exames </v-card-title>

            <v-card-text>
              <v-container>
                <v-form v-model="validateFormNewExam">
                  <v-row>
                    <v-col cols="4" class="pa-1">
                      <text-field
                        required
                        :mask="['##/##/####']"
                        label="Data dos Exames"
                        :rules="[$validation.validDate()]"
                        class="pa-0"
                        v-model="newExam.date"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="8" class="pa-1">
                      <search-server-field
                        v-model="newExam.exam"
                        :cacheItems="false"
                        required
                        label="Exame"
                        path="exam"
                        class="pa-0"
                        :customFilter="filterNewExam"
                      />
                    </v-col>
                    <v-col cols="2" class="pa-1">
                      <text-field v-model="newExam.value" required label="Resultado" class="ma-0 pa-0"></text-field>
                    </v-col>
                    <v-col cols="2" class="pa-1 mt-5 justify-center">
                      <v-btn color="primary" small :disabled="!validateFormNewExam" @click="addNewExam()">
                        Adicionar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-form>
                <v-col md="12">
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="text-left">Exame</th>
                        <th class="text-left">Resultado</th>
                        <th class="text-left">Data</th>
                        <th class="text-left">Opções</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="newExam in newExams" :key="newExam.examName">
                        <td>{{ newExam.examName }}</td>
                        <td>{{ newExam.value }}</td>
                        <td>{{ newExam.textDate }}</td>
                        <td>
                          <v-btn small icon title="Remover" @click="deleteNewExam(newExam.examId)">
                            <v-icon>mdi-delete</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <v-row> </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
              <v-btn color="blue darken-1" text :disabled="!activateBtnSaveNewExams" @click="saveNewExams">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogExam" max-width="500px">
          <v-card>
            <v-card-title> Editar Exames </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col v-for="date in headersContent" :key="date.value + '||' + date.text" cols="12">
                    <v-text-field
                      v-model="editedItem[date.value]"
                      :label="date.text"
                      :disabled="!activateExamEditField(editedItem.examId, date.value)"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancelar </v-btn>
              <v-btn color="blue darken-1" text @click="saveExamLine"> Salvar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteExam" max-width="500px">
          <v-card>
            <v-card-title>Confirma a exclusão definitiva dos exames que você inseriu?</v-card-title>
            <v-card-text>Apenas os exames que você registrou serão excluídos.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">Sim</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="newDateForExamDialog" max-width="500px">
          <v-card>
            <v-card-title>Adicionar uma nova data de exame</v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <text-field
                    required
                    :mask="['##/##/####']"
                    label="Data do Exame"
                    :rules="[$validation.validDate()]"
                    class="pa-0"
                    v-model="newDateForExamObject.date"
                  />
                </v-col>
                <v-col>
                  <text-field
                    v-model="newDateForExamObject.value"
                    required
                    label="Resultado"
                    class="ma-0 pa-0"
                  ></text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="cancelNewDateForExam">Cancelar</v-btn>
              <v-btn color="blue darken-1" text @click="newDateForExam">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn small icon title="Adicionar data" @click="openNewDateForExamDialog(item)">
        <v-icon small> mdi-plus </v-icon>
      </v-btn>

      <v-btn small icon title="Editar" @click="editItem(item)">
        <v-icon small> mdi-pencil </v-icon>
      </v-btn>
      <v-btn small icon title="Excluir" @click="deleteItem(item)">
        <v-icon small> mdi-delete </v-icon>
      </v-btn>
    </template>
    <template v-slot:no-data>
      <v-btn color="primary" @click="mountTableData"> Recarregar </v-btn>
    </template>

    <template v-slot:[`item.${header.value}`]="{ item }" v-for="header in headersContent">
      <div :key="header.value">
        <div
          v-for="(elem, index) in item[header.value]"
          :key="`${header.value}_${index}`"
          :class="{ 'mt-1': index >= 1 }"
        >
          <span>
            {{
              item[header.value].length > 1
                ? `${elem.value}
        (${elem.physicianName})`
                : elem.value
            }}</span
          >
        </div>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import SearchServerField from './SearchServerField.vue'
import TextField from './TextField.vue'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')
const { mapGetters: authGettersMap } = createNamespacedHelpers('auth')

export default {
  components: {
    SearchServerField,
    TextField,
  },
  data: () => ({
    newDate: null,
    isValidFormNewDate: false,
    dialogDate: false,
    dialogExam: false,
    dialogNewExam: false,
    dialogExamUpdate: false,
    dialogDeleteExam: false,
    headersMenu: { text: 'Ações', value: 'actions', sortable: false },
    headerFirstColl: [
      {
        text: 'Exame',
        align: 'start',
        sortable: true,
        value: 'examName',
      },
    ],
    editedItem: {},
    exams: [],
    examsComboList: [],
    editedIndex: -1,
    patientAttendanceExams: [],
    newExams: [],
    newExam: {
      exam: null,
      date: null,
      value: null,
    },
    validateFormNewExam: false,
    newDateForExamDialog: false,
    newDateForExamObject: {
      examId: null,
      value: null,
      date: null,
    },
    newExamsUpdate: {
      date: null,
    },
  }),

  computed: {
    ...attendanceGettersMap(['attendance']),
    ...authGettersMap(['personId', 'isPhysician']),

    physicianId() {
      return this.attendance.physician.id
    },
    attendanceId() {
      return this.attendance.id
    },
    patientId() {
      return this.attendance.patient.id
    },
    headersContent() {
      const arrHeaders = [...new Set(this.exams.map((entry) => Object.keys(entry)).flat())].splice(2).filter((item) => {
        return !item.search(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)
      })
      return arrHeaders
        .map((date) => {
          return {
            text: this.$util.toFormattedDate(date),
            value: date,
          }
        })
        .sort((a, b) => new Date(a.value) - new Date(b.value))
    },
    headers() {
      return this.headerFirstColl.concat(this.headersContent, this.headersMenu)
    },
    newExamItemTable() {
      return {
        examId: this.newExam.exam?.id,
        examName: this.newExam.exam?.name,
        value: this.newExam?.value,
        date: this.$util.toIsoDate(this.newExam?.date),
        textDate: this.newExam?.date,
      }
    },
    activateBtnSaveNewExams() {
      return this.newExams.length != 0
    },
    urlDataTableList() {
      return `patient-attendance-exam/${this.patientId}`
    },
  },

  created() {
    this.mountTableData()
  },

  methods: {
    buildExamsObject() {
      let examsObject = {}
      this.exams.forEach((exam) => {
        examsObject[exam.examId] = { value: null }
      })
      this.newExamsUpdate = { ...this.newExamsUpdate, examsObject }
    },
    async saveExamsUpdate() {
      const editedDate = this.$moment(this.newExamsUpdate.date).format('YYYY-DD-MM')
      for (const [key, value] of Object.entries(this.newExamsUpdate.examsObject)) {
        if (value.value) {
          try {
            await this.$api.upsertPatientAttendancaExam({
              patientId: this.patientId,
              attendanceId: this.attendanceId,
              examId: key,
              date: editedDate,
              value: value.value,
            })
          } catch {
            this.$root.error('Não foi possível adicionar a atualização. Tente novamente mais tarde.')
          } finally {
            this.dialogExamUpdate = false
            this.mountTableData()
            this.buildExamsObject()
          }
        }
      }
    },
    async mountTableData() {
      this.patientAttendanceExams = await this.getPatientAttedancExams()
      this.convertDtoToTableData()
      this.buildExamsObject()
    },

    async getPatientAttedancExams() {
      const functionToCall = this.$api.listCrud
      return await functionToCall(this.urlDataTableList, {})
    },

    getPatientAttedancExam(examId, date) {
      return (
        this.patientAttendanceExams.filter((exam) => {
          return exam.date == date && exam.examId == examId && exam.physicianId == this.physicianId
        })[0] ?? null
      )
    },

    activateExamEditField(examId, date) {
      const exam = this.getPatientAttedancExam(examId, date)
      return exam == null || exam.physicianId == this.physicianId
    },

    editItem(item) {
      this.editedIndex = this.exams.indexOf(item)
      this.editedItem = this.formatEditItem(item)

      this.dialogExam = true
    },

    formatEditItem(item) {
      const ob = {
        examId: item.examId,
        examName: item.examName,
        physicianId: this.physicianId,
      }
      const obDateKeys = Object.keys(item).filter((key) => key !== 'examId' && key !== 'examName')

      for (const dateKey of obDateKeys) {
        let examResult = item[dateKey].find((examDate) => examDate.physicianId === this.physicianId)

        if (!!examResult) {
          ob[dateKey] = examResult.value
        }
      }

      return ob
    },

    filterNewExam(item) {
      return !this.newExams.some((exam) => exam.examId === item.id)
    },
    addNewExam() {
      const newExamsFiltered = this.newExams.filter((el) => el.examId == this.newExamItemTable.examId)
      if (newExamsFiltered.length == 0) this.newExams.push(this.newExamItemTable)
      this.newExam.value = this.newExam.exam = null
    },
    openNewDateForExamDialog(item) {
      this.newDateForExamObject.examId = item.examId
      this.newDateForExamDialog = true
    },
    cancelNewDateForExam() {
      this.newDateForExamDialog = false
      this.newDateForExamObject = {
        value: null,
        date: null,
        examId: null,
      }
    },
    async newDateForExam() {
      if (!this.newDateForExamObject.examId || !this.newDateForExamObject.date || !this.newDateForExamObject.value) {
        return
      }

      const editedDate = this.$moment(this.newDateForExamObject.date, 'DD/MM/YYYY').format('YYYY-MM-DD')

      try {
        await this.$api.upsertPatientAttendancaExam({
          patientId: this.patientId,
          attendanceId: this.attendanceId,
          examId: this.newDateForExamObject.examId,
          date: editedDate,
          value: this.newDateForExamObject.value,
        })
        this.newDateForExamObject = {
          value: null,
          date: null,
          examId: null,
        }
      } catch {
        this.$root.error('Não foi possível adicionar o exame. Tente novamente mais tarde.')
      } finally {
        this.newDateForExamDialog = false
        this.mountTableData()
      }
    },

    deleteNewExam(examId) {
      this.newExams = this.newExams.filter((el) => {
        return el.examId != examId
      })
    },

    deleteItem(item) {
      this.editedIndex = this.exams.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDeleteExam = true
    },

    async deleteItemConfirm() {
      const examId = this.editedItem.examId
      for (const date in this.editedItem) {
        if (date == 'examId' || date == 'examName') {
          continue
        }
        const patientAttendanceExam = this.getPatientAttedancExam(examId, date)

        if (patientAttendanceExam.physicianId == this.physicianId) {
          await this.$api.removePatientAttendancaExam(patientAttendanceExam.id)
        }
      }
      this.mountTableData()
      this.closeDelete()
    },

    close() {
      this.dialogExamUpdate = false
      this.dialogExam = false
      this.dialogNewExam = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
      this.newExam = {}
      this.newExams = []
    },

    closeDelete() {
      this.dialogDeleteExam = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    async saveExamLine() {
      const examId = this.editedItem.examId
      for (const date in this.editedItem) {
        if (date == 'examId' || date == 'examName' || date == 'physicianId') {
          continue
        }
        const patientAttendanceExam = this.getPatientAttedancExam(examId, date) ?? { physicianId: this.physicianId }

        if (patientAttendanceExam.physicianId == this.physicianId) {
          await this.$api.upsertPatientAttendancaExam({
            patientId: this.patientId,
            attendanceId: this.attendanceId,
            examId: examId,
            date: date,
            value: this.editedItem[date],
          })
        }
      }
      this.mountTableData()
      this.close()
    },
    async saveNewExams() {
      for (const i in this.newExams) {
        await this.$api.upsertPatientAttendancaExam({
          patientId: this.patientId,
          attendanceId: this.attendanceId,
          ...this.newExams[i],
        })
      }
      this.mountTableData()
      this.close()
    },
    convertDtoToTableData() {
      const examsId = [
        ...new Set(
          this.patientAttendanceExams.map((exam) => {
            return exam.examId
          }),
        ),
      ]

      if (examsId) {
        const dataTable = examsId.map((examId) => {
          const patientAttendancExamsFiltered = this.patientAttendanceExams.filter((e) => e.examId == examId)

          const dates = {}

          patientAttendancExamsFiltered.forEach((patientAttendancExam) => {
            dates[patientAttendancExam.date] = dates[patientAttendancExam.date] ?? []
            dates[patientAttendancExam.date].push({
              value: patientAttendancExam.value,
              physicianName: patientAttendancExam.physicianName,
              physicianId: patientAttendancExam.physicianId,
            })
          })

          return {
            examId: examId,
            examName: patientAttendancExamsFiltered[0].exam.name,
            ...dates,
          }
        })

        this.exams = dataTable
      }
    },
  },
}
</script>
<style scoped>
.main-table :deep(.v-data-table-header) {
  vertical-align: unset;
}

.main-table :deep(.v-data-table__wrapper > table > thead > tr:last-child > th) {
  padding-top: 12px;
}
</style>
